import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IotNetworkCardDrawer from "./modules/IotNetworkCardDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import IotKeyListModal from "./component/iotKeyListModal.vue";
export default {
  name: 'IotNetworkCardList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    IotNetworkCardDrawer: IotNetworkCardDrawer,
    IotKeyListModal: IotKeyListModal
  },
  data: function data() {
    return {
      pagePath: '/site/iot/network/card',
      addDisabled: false,
      pageTitle: '物联网卡信息',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'iccid',
        colName: 'iccid',
        title: 'iccid',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'msisdn',
        colName: 'msisdn',
        title: 'msisdn',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '密钥名称',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'expiredAt',
        colName: 'expiredAt',
        title: '卡有效期',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '卡状态',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'used',
        colName: 'used',
        title: '已用流量（MB）',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'surplus',
        colName: 'surplus',
        title: '剩余流量（MB）',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'carrier',
        colName: 'carrier',
        title: '运营商',
        align: 'center',
        sorter: false
      }, {
        title: '备注',
        align: 'center',
        sorter: false,
        customRender: function customRender(t, r, index) {
          if (r.errorMsg) {
            return r.errorMsg;
          } else {
            return r.remark;
          }
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      // columns: [
      //   {
      //     title: '序号',
      //     dataIndex: '',
      //     key: 'rowIndex',
      //     width: 60,
      //     align: 'center',
      //     customRender: function (t, r, index) {
      //       return parseInt(index) + 1
      //     },
      //   },
      //   {
      //     dataIndex: 'iccid',
      //     colName: 'iccid',
      //     title: 'iccid',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'name',
      //     colName: 'name',
      //     title: '密钥名称',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'expiry_date',
      //     colName: 'expiry_date',
      //     title: '计费结束日期',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'data_usage',
      //     colName: 'data_usage',
      //     title: '当月流量（MB）',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'data_balance',
      //     colName: 'data_balance',
      //     title: '剩余流量（MB）',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'carrier',
      //     colName: 'carrier',
      //     title: '运营商',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'account_status_str',
      //     colName: 'account_status',
      //     title: '卡状态',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'customize_comment',
      //     colName: 'customize_comment',
      //     title: '卡备注',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     // dataIndex: 'remark',
      //     // colName: 'remark',
      //     title: '备注',
      //     align: 'center',
      //     sorter: false,
      //     customRender: function (t, r, index) {
      //       if (r.err_remark) {
      //         return r.err_remark
      //       } else {
      //         return r.remark
      //       }
      //     },
      //   },
      //   {
      //     title: '操作',
      //     dataIndex: 'action',
      //     align: 'center',
      //     width: 120,
      //     scopedSlots: { customRender: 'action' },
      //   },
      // ],
      // innerColumns: [
      //   {
      //     dataIndex: 'msisdn',
      //     colName: 'msisdn',
      //     title: 'msisdn',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'sp_code',
      //     colName: 'sp_code',
      //     title: '短信端口号',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'imsi',
      //     colName: 'imsi',
      //     title: 'imsi',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'imsi2',
      //     colName: 'imsi2',
      //     title: 'imsi2',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'data_plan',
      //     colName: 'data_plan',
      //     title: '套餐大小',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'active',
      //     colName: 'active',
      //     title: '激活状态',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'test_valid_date',
      //     colName: 'test_valid_date',
      //     title: '测试期起始时间',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'silent_valid_date',
      //     colName: 'silent_valid_date',
      //     title: '沉默期起始时间',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'outbound_date',
      //     colName: 'outbound_date',
      //     title: '出库日期',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'active_date',
      //     colName: 'active_date',
      //     title: '激活日期',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'support_sms',
      //     colName: 'support_sms',
      //     title: '是否支持短信',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'test_used_data_usage',
      //     colName: 'test_used_data_usage',
      //     title: '测试期已用流量',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'sim_type',
      //     colName: 'sim_type',
      //     title: 'sim卡类型',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'accumulated',
      //     colName: 'accumulated',
      //     title: '是否是累计卡',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'code',
      //     colName: 'code',
      //     title: '计费组',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'data_traffic_amount',
      //     colName: 'data_traffic_amount',
      //     title: '总流量',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'valid_date',
      //     colName: 'valid_date',
      //     title: '计费起始时间',
      //     align: 'center',
      //     sorter: false,
      //   },
      //   {
      //     dataIndex: 'out_data_usage',
      //     colName: 'out_data_usage',
      //     title: '超出用量',
      //     align: 'center',
      //     sorter: false,
      //   },
      // ],
      dataSource: [],
      siteId: '',
      visible: false,
      companyList: [],
      IotKeyList: [],
      companyId: '',
      userId: ''
    };
  },
  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('pro__Login_Userinfo'));
    this.userId = userInfo.value.id;
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.dataSource = [];
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
      console.log('this.siteId', this.siteId);
    },
    dataSource: function dataSource(newVal, oldVal) {
      newVal.forEach(function (item, index) {
        var recordItem = [];
        item.active = item.active ? String(item.active) : '';
        item.accumulated = item.accumulated ? String(item.accumulated) : '';
        item.support_sms = item.support_sms ? String(item.support_sms) : '';
        recordItem.push(item);
        item['recordItem'] = recordItem;
      });
      this.dataSource = newVal;
      console.log('this.dataSource', this.dataSource);
    },
    deep: true
  },
  computed: {},
  methods: {
    showModal: function showModal() {
      this.$refs.iotKeyListModal.visible = true;
      this.$refs.iotKeyListModal.getIotKeyList();
    },
    handleDelete1: function handleDelete1(id) {
      this.handleDelete(id);
      this.dataSource = [];
    }
  }
};